export const iconFontAwesomeAnimalsFish = (
	<i className="fa-solid fa-fish"></i>
);
